/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AsanaWrapperQueryVariables = {};
export type AsanaWrapperQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"AsanaWrapper_viewer">;
    };
};
export type AsanaWrapperQuery = {
    readonly response: AsanaWrapperQueryResponse;
    readonly variables: AsanaWrapperQueryVariables;
};



/*
query AsanaWrapperQuery {
  viewer {
    ...AsanaWrapper_viewer
    id
  }
}

fragment AsanaWrapper_viewer on Viewer {
  user {
    id
    orgs(first: 1000000) {
      edges {
        node {
          id
          asanaAccountErrorable {
            __typename
            ... on AsanaAccount {
              hasAsanaCredentials
            }
            ... on GraphEntityError {
              message
              statusCode
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          primaryOrgCalendar
          flowStates(first: 1000000) {
            edges {
              node {
                id
                flowKey
                previousState
                current {
                  state
                  percentComplete
                  errorMessage
                  id
                }
                pending {
                  state
                  percentComplete
                  errorMessage
                  id
                }
              }
            }
          }
        }
      }
    }
    flowStates(first: 1000000) {
      edges {
        node {
          id
          flowKey
          previousState
          current {
            state
            percentComplete
            errorMessage
            id
          }
          pending {
            state
            percentComplete
            errorMessage
            id
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v2 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any,
        (v0 /*: any*/)
    ], v3 = {
        "alias": null,
        "args": (v1 /*: any*/),
        "concreteType": "FlowStateConnection",
        "kind": "LinkedField",
        "name": "flowStates",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowStateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flowKey",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previousState",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "current",
                                "plural": false,
                                "selections": (v2 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "pending",
                                "plural": false,
                                "selections": (v2 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "flowStates(first:1000000)"
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "AsanaWrapperQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AsanaWrapper_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AsanaWrapperQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "asanaAccountErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "hasAsanaCredentials",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "AsanaAccount",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "message",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "statusCode",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v0 /*: any*/)
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        (v3 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v3 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v0 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "49ee3032a09649d6712f4b2ca00dcaf3",
            "id": null,
            "metadata": {},
            "name": "AsanaWrapperQuery",
            "operationKind": "query",
            "text": "query AsanaWrapperQuery {\n  viewer {\n    ...AsanaWrapper_viewer\n    id\n  }\n}\n\nfragment AsanaWrapper_viewer on Viewer {\n  user {\n    id\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          asanaAccountErrorable {\n            __typename\n            ... on AsanaAccount {\n              hasAsanaCredentials\n            }\n            ... on GraphEntityError {\n              message\n              statusCode\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          primaryOrgCalendar\n          flowStates(first: 1000000) {\n            edges {\n              node {\n                id\n                flowKey\n                previousState\n                current {\n                  state\n                  percentComplete\n                  errorMessage\n                  id\n                }\n                pending {\n                  state\n                  percentComplete\n                  errorMessage\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    flowStates(first: 1000000) {\n      edges {\n        node {\n          id\n          flowKey\n          previousState\n          current {\n            state\n            percentComplete\n            errorMessage\n            id\n          }\n          pending {\n            state\n            percentComplete\n            errorMessage\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'b0ecb971802bdd6f738797eca5cc1db5';
export default node;
